const PREFIX = "MYANALOGMODAL_",
  SET = "SET_";

/**
 * @name HIDE_MODAL
 * @const
 * @description Hides the modal.
 */
export const HIDE_MODAL = PREFIX + "HIDE_MODAL";

/**
 * @name SHOW_MODAL
 * @const
 * @description Show the modal.
 */
export const SHOW_MODAL = PREFIX + "SHOW_MODAL";

/**
 * @name SET_VALUES
 * @const
 * @description Sets the values for the modal.
 */
export const SET_VALUES = PREFIX + SET + "VALUES";

/**
 * @name SET_ERROR
 * @const
 * @description Sets the values for the modal.
 */
export const SET_ERROR = PREFIX + SET + "ERROR";

/**
 * @name SET_DROPDOWN
 * @const
 * @description Sets the values for the modal.
 */
export const SET_DROPDOWN_VALUES = PREFIX + SET + "DROPDOWN_VALUES";


/**
 * @name SET_TRANSLATION
 * @const
 * @description Sets the values for the modal.
 */
export const SET_TRANSLATION_VALUES = PREFIX + SET + "TRANSLATION_VALUES";


/**
 * @name SET_SUCCESS
 * @const
 * @description Sets the success state for the modal.
 */
export const SET_SUCCESS = PREFIX + SET + "SUCCESS";
